export const APP_CONFIG = {
  DEFAULT_LOCALE: 'de',
  DATE_FORMAT: 'DD MMM YYYY',
  DATE_TIME_FORMAT: 'DD MMM YYYY, hh:mm A',
  DEBOUNCE_DELAY_MS: 400,
  DEFAULT_PAGE_SIZE: 10,
  TOAST_AUTO_CLOSE_MS: 4000,
} as const;

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
} as const;
